import React,{useEffect,useState} from 'react'
import SubmitButton from '../../components/SubmitButton'
import {Error, Success} from '../../components/Status'
import {useGetRoles} from '../../hooks/roles/useGet'
import {useUpdateUser} from '../../hooks/users/useUpdate'
import {useGetBranches} from '../../hooks/branches/useGet'
import Select from '../../components/Select'
import TextField from '../../components/TextField'

const UpdateUser = ({user}) => {
  // STATES
  // PAYLOAD STATE
  const [state, setState] = useState({
    roleId: user.roleId,
    branchId: user.branchId,
    activeStatus:user.officerStatus
  });
  // MISC STATE
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // MISC DATA
//   GET ROLES
  const { data: roles, isSuccess: gotRoles } = useGetRoles();
  const roleSelectOptions = roles?.map((item) => ({
    name: item.roleName,
    value: item.roleId,
  }));

//   GET BRANCHES
const { data: branches, isSuccess: gotBranches } = useGetBranches(1,100);
const branchSelectOptions = branches?.map((item) => ({
  name:`${item.branchCode} (${item.branchName})`,
  value: item.branchId,
}));

  // MUTATION
  const {
    mutate: updateUser,
    error: updateError,
    isLoading,
    isSuccess,
  } = useUpdateUser(user.officerId,state);

  // HANDLERS
  // INPUT HANDLER
  const handleChange = ({ target: { name, value } }) => {

    setState({ ...state, [name]: value });
  };


  const handleCheck=()=>{
    setState({...state,activeStatus:!state.activeStatus})
}

  // SUBMIT HANDLER
  const handleSubmit = (e) => {
    e.preventDefault();
    // REFRESH ERROR
    setError("");
    updateUser();
  };


  // EFFECTS
  useEffect(() => {
    if (isSuccess) {
      setSuccess("User updated successfully");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (updateError) {
      const message = updateError?.response?.data?.message;
      setError(message);
    }
  }, [updateError]);




  return (
    <form className="w-full flex flex-col space-y-5" onSubmit={handleSubmit}>
      {success.length > 0 && <Success>{success}</Success>}
      {error.length > 0 && <Error>{error}</Error>}

      {gotBranches && (
        <Select
          name="branchId"
          onChange={handleChange}
          placeholder="Select an option"
          defaultValue={state.branchId}
          label="Branch"
          options={branchSelectOptions}
          required
        />
      )}
       {gotRoles && (
        <Select
          name="roleId"
          onChange={handleChange}
          placeholder="Select an option"
          defaultValue={state.roleId}
          label="Role"
          options={roleSelectOptions}
          required
        />
      )}
      {!user.officerStatus&& <TextField type='checkbox' label='Activate' name='activeStatus' checked={state.activeStatus} onChange={handleCheck} />}
      <SubmitButton loading={isLoading}>Submit</SubmitButton>
    </form>
  );
};

export default UpdateUser
